/**
 * LOP — Console helper for listing-price debugging.
 * Loaded from layout/theme.liquid (no defer) so `LOP_AUDIT_PRICES` exists as soon as the page parses.
 *
 * In DevTools Console run:
 *   LOP_AUDIT_PRICES()
 *
 * Chrome may block pasting into the console until you type: allow pasting
 */
(function () {
  'use strict';

  window.LOP_AUDIT_PRICES = function () {
    var items = Array.prototype.slice.call(document.querySelectorAll('.product-item'));
    var rows = items.map(function (el) {
      var priceEl = el.querySelector('.product-item__price');
      var sEl = priceEl ? priceEl.querySelector('s') : null;
      var saleEl = priceEl ? priceEl.querySelector('.sale, .b40-vprice') : null;
      var titleEl = el.querySelector('.product-item__product-title');
      var renderedCompareAt = sEl ? String(sEl.textContent || '').trim() : '';
      var renderedSale = saleEl ? String(saleEl.textContent || '').trim() : '';
      var renderedFull = priceEl ? String(priceEl.textContent || '').trim().replace(/\s+/g, ' ') : '';
      return {
        title: titleEl ? String(titleEl.textContent || '').trim() : '',
        currentVariantId: el.getAttribute('data-current-variant-id'),
        listingVariantId: el.getAttribute('data-lop-listing-variant-id'),
        variantMatch: el.getAttribute('data-lop-variant-match'),
        listingMatch: el.getAttribute('data-lop-listing-match'),
        colorOptionIndex: el.getAttribute('data-lop-color-option-index'),
        currentColor: el.getAttribute('data-lop-current-color'),
        listingPriceCents: el.getAttribute('data-lop-listing-price-cents'),
        listingCompareAtCents: el.getAttribute('data-lop-listing-compare-at-cents') || '',
        renderedCompareAt: renderedCompareAt,
        renderedSale: renderedSale,
        renderedFull: renderedFull,
        hasStrikethroughInHTML: !!(sEl && renderedCompareAt),
      };
    });
    if (typeof console !== 'undefined' && console.table) {
      console.table(rows);
    }
    return rows;
  };
})();
